import React from "react";

export interface IconSyncProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  fill?: string;
}

export const IconSync: React.FC<IconSyncProps> = ({
  width = 24,
  height = 24,
  fill = "#006231",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.2474 17.6489L17.6474 21.2489C17.3024 21.5939 16.7887 21.6951 16.3387 21.5076C15.8887 21.3201 15.5999 20.8851 15.5999 20.4014V18.0014H3.5999C2.93615 18.0014 2.3999 17.4651 2.3999 16.8014C2.3999 16.1376 2.93615 15.6014 3.5999 15.6014H15.5999V13.2014C15.5999 12.7176 15.8924 12.2789 16.3424 12.0914C16.7924 11.9039 17.3062 12.0089 17.6512 12.3501L21.2512 15.9501C21.7199 16.4189 21.7199 17.1801 21.2512 17.6489H21.2474ZM2.7524 8.04885C2.28365 7.5801 2.28365 6.81885 2.7524 6.3501L6.3524 2.7501C6.6974 2.4051 7.21115 2.30385 7.66115 2.49135C8.11115 2.67885 8.3999 3.1176 8.3999 3.60135V6.00135H20.3999C21.0637 6.00135 21.5999 6.5376 21.5999 7.20135C21.5999 7.8651 21.0637 8.40135 20.3999 8.40135H8.3999V10.8014C8.3999 11.2851 8.1074 11.7239 7.6574 11.9114C7.2074 12.0989 6.69365 11.9939 6.34865 11.6526L2.74865 8.0526L2.7524 8.04885Z"
      fill={fill}
    />
  </svg>
);
